
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 16 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.865 3.865a.5.5 0 01.936 0l1.242 3.315a.5.5 0 00.3.295l3.351 1.208a.5.5 0 010 .941l-3.352 1.208a.5.5 0 00-.299.295l-1.242 3.316a.5.5 0 01-.936 0l-1.242-3.316a.5.5 0 00-.299-.295L3.972 9.624a.5.5 0 010-.94l3.352-1.209a.5.5 0 00.299-.295l1.242-3.315zM3.052.75a.3.3 0 01.562 0l.566 1.51a.3.3 0 00.18.178l1.523.549a.3.3 0 010 .564l-1.523.55a.3.3 0 00-.18.177l-.566 1.51a.3.3 0 01-.562 0l-.566-1.51a.3.3 0 00-.179-.177L.783 3.55a.3.3 0 010-.564l1.524-.55a.3.3 0 00.18-.176L3.051.75zm0 10.461a.3.3 0 01.562 0l.566 1.511a.3.3 0 00.18.177l1.523.55a.3.3 0 010 .564l-1.523.55a.3.3 0 00-.18.176l-.566 1.511a.3.3 0 01-.562 0l-.566-1.51a.3.3 0 00-.179-.178l-1.524-.549a.3.3 0 010-.565l1.524-.549a.3.3 0 00.18-.177l.565-1.51z"}})])
          )
        }
      }
    